export default function getCopyright() {
  //return 'Copyright &copy; madai';
  return 'Copyright © Madai';
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/getCopyright.js
 **/